<template>
  <div id="mapaCah"></div>
</template>

<style>
#mapaCah {
  width: 100%;
  height: 450px;
  z-index: 1;
  border-radius: 10px;
}
</style>

<script>
import leaflet from "leaflet";
// import leaflet css
import "leaflet/dist/leaflet.css";
import { onMounted } from "vue";
export default {
  setup() {
    let mymap;
    onMounted(() => {
      mymap = leaflet.map("mapaCah").setView([-12.0417824, -75.3211706], 16);

      leaflet
        .tileLayer(
          "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
          {
            maxZoom: 17,
            minZoom: 8,
            attribution: "Instituto Geofísico del Perú",
          }
        )
        .addTo(mymap);

      leaflet
        .tileLayer(
          "https://services.arcgisonline.com/arcgis/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}",
          {
            maxZoom: 17,
            minZoom: 8,
          }
        )
        .addTo(mymap);

      // Custom icon svg
      const icon = leaflet.icon({
        iconUrl: require("@/assets/icons/Mark.svg"),
        iconSize: [40, 40],
      });

      leaflet
        .marker([-12.0417824, -75.3211706], { icon })
        .bindPopup(`Observatorio Geofísico de Huancayo`)
        .openPopup()
        .addTo(mymap);
    });
  },
};
</script>
